function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import { SyncLoader } from 'react-spinners';
import { logout } from 'js/store/actions/auth';
import subscriptions from 'js/services/payments/subscriptions';
import { Container, PanelContainer, Panel, Title, Sentence, SpinnerBox } from './style';

var delay = function delay(ms) {
  return new Promise(function (res) {
    return setTimeout(res, ms);
  });
};

var PaymentValidation =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PaymentValidation, _React$Component);

  function PaymentValidation() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PaymentValidation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PaymentValidation)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      action: null,
      color: 'gray'
    };
    return _this;
  }

  _createClass(PaymentValidation, [{
    key: "next",
    value: function next(message, plan) {
      if (message === 'Billing Agreement Created Successfully') {
        logout(plan);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var plan = this.props.match.params.plan;
      var token = this.props.history.location.search.substr(7);
      var pathname = this.props.location.pathname;
      var cancel = pathname.startsWith('/cancel');
      var approve = pathname.startsWith('/approve');

      if (plan === ':normal' && approve) {
        subscriptions.executeNormalSubscriptions(token).then(function (validation) {
          _this2.next(validation.message, plan);
        });
      }

      if (plan === ':premium' && approve) {
        subscriptions.executePremiumSubscriptions(token).then(function (validation) {
          _this2.next(validation.message, plan);
        });
      }

      if ([':normal', ':premium'].includes(plan) && cancel) {
        delay(1000).then(function () {
          return _this2.props.history.push('/choose-plan');
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var plan = this.props.match.params.plan;
      var pathname = this.props.location.pathname;
      var approved = pathname.startsWith('/approve');
      return React.createElement(Container, null, React.createElement(PanelContainer, null, React.createElement(Panel, null, React.createElement(Title, null, "".concat(plan.replace(':', '').toUpperCase(), " COSMOS")), React.createElement(Sentence, null, approved ? 'Creating account' : 'An error ocurred! Try again later'), React.createElement(SpinnerBox, null, React.createElement(SyncLoader, {
        color: approved ? '#9de042' : 'red'
      })))));
    }
  }]);

  return PaymentValidation;
}(React.Component);

export { PaymentValidation as default };
PaymentValidation.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isMobileWidth: PropTypes.bool.isRequired
};